import { forwardRef } from 'react'
import classNames from 'classnames'
import type { ComponentPropsWithRef } from 'react'
import type { CommonProps } from '../@types/common'

export interface ThProps extends ComponentPropsWithRef<'th'>, CommonProps {}

const Th = forwardRef<HTMLTableCellElement, ThProps>((props, ref) => {
    const { children, className, ...rest } = props

    const thClass = classNames(className)

    return (
        <th ref={ref} className={thClass} {...rest}>
            {children}
        </th>
    )
})

Th.displayName = 'Th'

export default Th 